// (A) 중립 List API — antd 미접촉. (B) PlainList/PlainListItem 에 위임.
// antd List / List.Item 복합을 OmwList + OmwListItem 으로 분리. dataSource 는 제네릭.
import type { CSSProperties, MouseEvent, ReactNode } from 'react'
import { PlainList, PlainListItem } from '../_impl/PlainList'

/** 로딩 오버레이(실측: ThreadList — spinner+지연 로딩). antd Spin 세부를 중립화. */
export interface OmwListLoading {
  spinning?: boolean
  indicator?: ReactNode
  wrapperClassName?: string
}

export interface OmwListProps<T> {
  dataSource?: T[]
  renderItem?: (item: T, index: number) => ReactNode
  itemLayout?: 'horizontal' | 'vertical'
  /** 실측: locale.emptyText 를 중립 emptyText 로 흡수. */
  emptyText?: ReactNode
  /** 실측: ThreadList 로딩 오버레이. */
  loading?: OmwListLoading
  /** 실측: ThreadList 하단 추가 로딩 인디케이터. */
  footer?: ReactNode
  /** 리스트 헤더(→ antd List header). 실측: ninegqlUI 리스트 컬럼 헤더. */
  header?: ReactNode
  className?: string
  style?: CSSProperties
  'data-testid'?: string
  /** data-* 통과(실측: data-mailbox-role 등). */
  [dataAttr: `data-${string}`]: string | undefined
  children?: ReactNode
}

export interface OmwListItemProps {
  className?: string
  style?: CSSProperties
  onClick?: (e: MouseEvent<HTMLElement>) => void
  /** 실측: ninegqlUI 리스트 항목 mousedown(tableClickRange 판정). */
  onMouseDown?: (e: MouseEvent<HTMLElement>) => void
  'data-testid'?: string
  /** data-* 통과(실측: data-email-id). */
  [dataAttr: `data-${string}`]: string | undefined
  children?: ReactNode
}

export function OmwList<T>(props: OmwListProps<T>) {
  return <PlainList {...props} />
}

export function OmwListItem(props: OmwListItemProps) {
  return <PlainListItem {...props} />
}
